import { render, staticRenderFns } from "./my-course.vue?vue&type=template&id=10a509d9&scoped=true&"
import script from "./my-course.vue?vue&type=script&lang=js&"
export * from "./my-course.vue?vue&type=script&lang=js&"
import style0 from "./my-course.vue?vue&type=style&index=0&id=10a509d9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a509d9",
  null
  
)

export default component.exports